export default __webpack_public_path__ + "static/media/it-82.b5fabe3b.svg";